module.exports = __webpack_public_path__ + "fonts/IstokWeb-Italic.be07d263.woff";